
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'8-4'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            메뉴 관리 - 자주 묻는 질문 {{ $route.query.frequently_questions_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.frequently_questions_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='frequently_questions_title'>타이틀<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'frequently_questions_title'
                maxLength="50"
                placeholder = "타이틀을 입력해 주세요.(50자 이내)"
                v-model="formData.frequentlyQuestionsTitle"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.frequentlyQuestionsTitleError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='frequently_questions_top_status'>상단 공지<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="frequently_questions_top_status"
                v-model="formData.frequentlyQuestionsTopStatus"
              >
                <option value='0'>미공지</option>
                <option value='1'>공지</option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='frequently_questions_write'>작성자<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'frequently_questions_write'
                maxLength="10"
                placeholder = "작성자를 입력해 주세요.(10자 이내)"
                v-model="formData.frequentlyQuestionsWrite"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.frequentlyQuestionsWriteError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='frequently_questions_views'>조회수</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'frequently_questions_views'
                readonly
                v-model="formData.frequentlyQuestionsViews"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='frequently_questions_status'>노출 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="frequently_questions_status"
                v-model="formData.frequentlyQuestionsStatus"
              >
                <option value='1'>노출</option>
                <option value='2'>미노출</option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='frequently_questions_editor'>내용</label>
              <custom-textarea
                v-model="formData.frequentlyQuestionsEditor"
                :id="'frequently_questions_editor'"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import CustomTextarea from '../../ETC/CustomTextarea.vue'
import { editorsReady } from '../../ETC/editor/form'
import {
  get_frequently_questions_one,
  insert_frequently_questions,
  update_frequently_questions,
  get_session_admin

} from '../../ETC/Axios.vue'

export default {
  name: 'AdminFrequentlyQuestionsManagementAdd',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner,
    CustomTextarea
  },
  setup () {
    return {
      formData: ref({
        frequentlyQuestionsTitle: '',
        frequentlyQuestionsTopStatus: '0',
        frequentlyQuestionsWrite: '',
        frequentlyQuestionsViews: '0',
        frequentlyQuestionsStatus: 1,
        frequentlyQuestionsEditor: ''
      }),
      errorData: ref({
        frequentlyQuestionsTitleError: '',
        frequentlyQuestionsWriteError: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    check_form: function () {
      // 업로드 중인 이미지가 본문에서 누락되지 않도록 저장 전에 확인한다.
      if (!editorsReady(this)) return
      let continue_add = true
      if (this.formData.frequentlyQuestionsTitle === '') {
        this.errorData.frequentlyQuestionsTitleError = '타이틀을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.frequentlyQuestionsTitleError = ''
      }
      if (this.formData.frequentlyQuestionsWrite === '') {
        this.errorData.frequentlyQuestionsWriteError = '작성자를 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.frequentlyQuestionsWriteError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.frequently_questions_ID === undefined) {
          insert_frequently_questions(
            this.formData.frequentlyQuestionsTitle,
            this.formData.frequentlyQuestionsTopStatus,
            this.formData.frequentlyQuestionsWrite,
            this.formData.frequentlyQuestionsEditor,
            this.formData.frequentlyQuestionsStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminFrequentlyQuestionsManagement'
          })
        } else {
          update_frequently_questions(
            this.$route.query.frequently_questions_ID,
            this.formData.frequentlyQuestionsTitle,
            this.formData.frequentlyQuestionsTopStatus,
            this.formData.frequentlyQuestionsWrite,
            this.formData.frequentlyQuestionsEditor,
            this.formData.frequentlyQuestionsStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminFrequentlyQuestionsManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.frequently_questions_ID !== undefined) {
      get_frequently_questions_one(this.$route.query.frequently_questions_ID).then((result) => {
        this.formData.frequentlyQuestionsTitle = result.frequently_questions[0].frequently_questions_title
        this.formData.frequentlyQuestionsTopStatus = result.frequently_questions[0].frequently_questions_top_status
        this.formData.frequentlyQuestionsWrite = result.frequently_questions[0].frequently_questions_write
        this.formData.frequentlyQuestionsViews = result.frequently_questions[0].frequently_questions_views
        this.formData.frequentlyQuestionsStatus = result.frequently_questions[0].frequently_questions_status
        this.formData.frequentlyQuestionsEditor = result.frequently_questions[0].frequently_questions_editor
      })
    } else {
      get_session_admin().then(result => {
        if (result === '') {
          alert('로그인 유지시간이 만료되었습니다.')
          window.location.href = '/AdminLogin'
        } else {
          this.formData.frequentlyQuestionsWrite = result.admin_name
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/CommunityManagement/AdminFrequentlyQuestionsManagementAdd.vue